import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { PerfilEnum } from '@core/models/perfil.models';
import { AuthenticationService } from '@core/auth/authentication.service';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { StorageService } from '@shared/utils/services/storage.service';
import { EStorage } from '@shared/utils/enums/storage.enum';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private router: Router, private authenticationService: AuthenticationService,
        private permissionsService: NgxPermissionsService, public storageService: StorageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authenticationService.isLoggedIn
            .pipe(
                take(1),
                map((isLoggedIn: boolean) => {
                    if (!isLoggedIn) {
                        this.router.navigate(['/login']);
                        return false;
                    }

                    this.checkIfUserHasPermissionForMethod(state)

                    if (this.authenticationService.currentUserValue && this.authenticationService.currentUserValue.funcionalidades && Array.isArray(this.authenticationService.currentUserValue.funcionalidades))
                        this.permissionsService.loadPermissions(this.authenticationService.currentUserValue.funcionalidades);
                    let can = true;
                    if (route.data && route.data.roles && this.authenticationService.currentUserValue && this.authenticationService.currentUserValue.funcionalidades && Array.isArray(this.authenticationService.currentUserValue.funcionalidades)) {
                        can = route.data.roles.some(x => this.authenticationService.currentUserValue.funcionalidades.some(z => z == x));
                        if (!can) {
                            this.router.navigate(['acessoNaoPermitido']);
                        }
                    }
                    return can;
                })
            );
    }

    checkIfUserHasPermissionForMethod(route: RouterStateSnapshot) {
        if (!route.url || !route.url.includes('/consulta/')) return

        const storageMenuValue = this.storageService.get({ storageKey: EStorage.MENU })

        let ramoRouteParam = route.url.split('/')[2]
        let produtoRouteParam = route.url.split('/')[3]
        let metodoRouteParam = route.url.split('/')[4]

        const ramo = storageMenuValue.value.find((ramo) => {
            return String(ramo.id) == ramoRouteParam
        })

        const produto = ramo?.produtos.find((produto) => {
            return String(produto.idProduto) == produtoRouteParam
        })

        const metodo = produto.metodos.find((metodo) => {
            return String(metodo.id) == metodoRouteParam
        })


        return metodo?.acesso ? ({}) : this.router.navigate(['acessoNaoPermitido'])
    }
}